module.exports = __webpack_public_path__ + "87fe808fb1a3e91868ac311e721a39a9.pdf";